import { Box, Button, Drawer, IconButton } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import QuickPinchZoom, { make3dTransformValue } from "react-quick-pinch-zoom";
import React, { useState, useCallback, useRef, useEffect } from "react";
import { goAppUrl } from "assets/js/apphandle";

export function DrawerProduct(props) {
  const { flyer, drawerHigh, handleDrawerHighClose } = props;

  const imgRef = useRef([]);

  const [activeIndex, setActiveIndex] = useState(0);
  const [isZoom, setIsZoom] = useState(false);

  const slideChange = (swipe) => {
    setActiveIndex(swipe.realIndex);

    const value = make3dTransformValue({ x: 0, y: 0, scale: 1 });

    _.forEach(imgRef.current, (item, i) => {
      item.style.setProperty("transform", value);
    });
  };

  const onUpdate = useCallback(({ x, y, scale }) => {
    if (scale > 1) setIsZoom(true);
    else setIsZoom(false);

    const img = imgRef.current[activeIndex];

    if (img) {
      const value = make3dTransformValue({ x, y, scale });
      img.style.setProperty("transform", value);
    }
  });

  return (
    <Drawer
      anchor="bottom"
      open={drawerHigh}
      onClose={handleDrawerHighClose}
      className="drawer-common-bottom size-high"
    >
      <div className="drawer-head">
        <h3>{flyer.ttl} 전단</h3>
        <IconButton
          aria-label="close"
          className="btn-close"
          onClick={handleDrawerHighClose}
        >
          <span className="hidden">닫기</span>
        </IconButton>
      </div>

      <div className="drawer-body">
        <Swiper
          pagination={isZoom ? false : true}
          modules={[Pagination]}
          className="mySwiper"
          onSlideChange={slideChange}
        >
          {flyer &&
            flyer.imgUrls &&
            flyer.imgUrls.map((img, i) => (
              <SwiperSlide key={`flyer-${i}`}>
                <QuickPinchZoom
                  onUpdate={onUpdate}
                  draggableUnZoomed={false}
                  // onZoomStart={() => setIsZoom(true)}
                  // onZoomUpdate={() => setIsZoom(true)}
                  // onZoomEnd={() => setIsZoom(false)}
                  // onZoomStart={() => console.log(" --- onZoomStart")}
                  // onZoomEnd={() => console.log(" --- onZoomEnd")}
                  // onZoomUpdate={() => console.log(" --- onZoomUpdate")}
                  // onDragStart={() => console.log(" --- onDragStart")}
                  // onDragEnd={() => console.log(" --- onDragEnd")}
                  // onDragUpdate={() => console.log(" --- onDragUpdate")}
                  // onDoubleTap={() => console.log(" --- onDoubleTap")}
                >
                  <img
                    ref={(elem) => (imgRef.current[i] = elem)}
                    src={img}
                    style={{ width: "100%" }}
                  />
                </QuickPinchZoom>
              </SwiperSlide>
            ))}
        </Swiper>
        <button
          onClick={() => {
            goAppUrl(flyer.screenReaderUrl, 1);
            // location.href = `csrmegamart://internal-url?close=N&new=Y&url=${
            //   flyer.screenReaderUrl
            // }&d=&top=1`;
            // location.href = flyer.screenReaderUrl;
          }}
          alt="시각장애인용 대체페이지로 이동"
          title="시각장애인용 대체페이지로 이동"
          style={{
            border: "none",
            width: 1,
            height: 1,
            backgroundColor: "white",
          }}
        >
          <span
          //  className="hidden"
          />
        </button>
        {/* //Dir storeCode 확인해서 변경하기 */}
      </div>
    </Drawer>
  );
}
